import ApiHandler from "./ApiHandler";

const Announcement = {
  getAll: async (query) => await ApiHandler.i.auth().get(`/announcement?${query.toString()}`),
  getCountOfNew: async (query) => await ApiHandler.i.auth().get(`/announcement/count-of-new?${query ? query.toString() : ''}`),
  getLast: async () => await ApiHandler.i.auth().get('/announcement/last'),
  getOne: async (announcementId) => await ApiHandler.i.auth().get(`/announcement/${announcementId}`),
  putOne: async (announcementId, data, options) => await ApiHandler.i.auth().put(`/announcement/${announcementId}`, data, options),
  postOne: async (data, options) => await ApiHandler.i.auth().post('/announcement', data, options),
  deleteOne: async (announcementId) => await ApiHandler.i.auth().delete(`/announcement/${announcementId}`),
};

export default Announcement;